import { makeUseQueryHook } from '@graphql/functions'
import { EMPTY_SECTION_OF_STEPS } from '@graphql/placeholders'
import { GetSectionOfStepsDocument } from '@graphql/queries/GetSteps.graphql'
import { usePersonalizations } from '@lib/hooks/usePersonalizations'
import { renderTemplate } from '@lib/utils/text'
import { produce } from 'immer'

/**
 * Returns the personalized content for a section.
 */
export const useSectionOfSteps = (id: string) => {
    const personalizations = usePersonalizations()
    const result = useGetSectionOfSteps({ variables: { id } })

    const section = produce(
        result.data?.section ?? EMPTY_SECTION_OF_STEPS,
        (draft) => {
            const { section, steps, action } = draft

            if (section) {
                section.title = renderTemplate(section.title, personalizations)
                section.subtitle = renderTemplate(
                    section.subtitle,
                    personalizations,
                )
            }

            if (action && 'title' in action) {
                action.title = renderTemplate(action.title, personalizations)
            }

            if (steps) {
                for (const item of steps.items) {
                    item.title = renderTemplate(item.title, personalizations)
                    item.subtitle = renderTemplate(
                        item.subtitle,
                        personalizations,
                    )
                }
            }
        },
    )

    return { section, ...result }
}

const useGetSectionOfSteps = makeUseQueryHook({
    query: GetSectionOfStepsDocument,
})
